export const sortByLabel = (x, y) => x.label.toLowerCase().localeCompare(y.label.toLowerCase());

const formatDivisionsAndTeams = (seasonData, selectedDivision) => {
  const divisionsAndProgram = seasonData && seasonData.showSeason ? seasonData.showSeason : null;
  const divisionsFilter = divisionsAndProgram
    ? [
        { value: divisionsAndProgram.tsDivisionId, label: divisionsAndProgram.program.name },
        ...seasonData.showSeason.divisions
          .map(({ id, name }) => ({
            value: id,
            label: name,
          }))
          .sort(sortByLabel),
      ]
    : [{ label: 'No divisions in this season', disabled: true }];

  const teamsFilter =
    seasonData?.showSeason && seasonData?.showSeason?.teams
      ? [
          { value: 'noTeam', label: 'Unrostered / No Team' },
          ...seasonData.showSeason.teams
            .filter(({ divisionId }) => divisionId === selectedDivision)
            .map(({ id, name, divisionId }) => {
              const division =
                divisionId && seasonData.showSeason.divisions
                  ? seasonData.showSeason.divisions.find((division) => division.id === divisionId)
                  : null;

              return {
                value: id,
                label: name,
                subtext: division?.name,
              };
            })
            .sort(sortByLabel),
        ]
      : [{ value: 'noTeam', label: 'Unrostered / No Team' }];

  return [divisionsFilter, teamsFilter];
};

export default formatDivisionsAndTeams;
